const routes = [
  {
    path: "/",
    label: "Deployments",
  },
  {
    path: "/schedule",
    label: "Schedule",
  },
  {
    path: "/compare",
    label: "Compare",
  },
];

export default routes;
